export const ActionTypes = {
  SET_COUNTRIES: 'SET_COUNTRIES',
  SET_ALL_COUNTRIES: 'SET_ALL_COUNTRIES'
};
